import Vue from 'vue';
import { removeHttp } from './utils';
const hpic = '//puui.qpic.cn/vupload/0/common_pic_h.png/0';
const vpic = '//puui.qpic.cn/vupload/0/common_pic_v.png/0';
const creatorpic = '//vfiles.gtimg.cn/vupload/20210329/843d7e1617007458136.png';
Vue.directive('src', (el, { value, modifiers }) => {
    if (el.tagName !== 'IMG') {
        return;
    }
    el.src = modifiers.v ? vpic : hpic;
    const val = removeHttp(value);
    let img = new Image();
    img.onload = () => {
        el.src = val;
        img.onload = null;
        img.onerror = null;
        img = null;
    };
    img.onerror = () => {
        img.onload = null;
        img.onerror = null;
        img = null;
    };
    img.src = val;
});
Vue.directive('avatar-src', (el, { value }) => {
    if (el.tagName !== 'IMG') {
        return;
    }
    el.src = creatorpic;
    const val = removeHttp(value);
    let img = new Image();
    img.onload = () => {
        el.src = val;
        img.onload = null;
        img.onerror = null;
        img = null;
    };
    img.onerror = () => {
        img.onload = null;
        img.onerror = null;
        img = null;
    };
    img.src = val;
});
Vue.directive('wind', {
    inserted(el) {
        // debugger
        // windBoss.bind(el, '')
        // console.log('update')
        el.setAttribute('__wind', '');
        txv.Boss.wind($(el.parentElement));
    },
    update(el) {
        // console.log('update')
        el.setAttribute('__wind', '');
        txv.Boss.wind($(el.parentElement));
    },
});
